// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cB4M","largestCol":"styles_largestCol__2A01n","smallestCol":"styles_smallestCol__14wZu"};